import React from 'react'

const PaletteCell = ({color}) => {
  return (
    <div className='palette-cell' style={{backgroundColor: `${color}`}}>{color}</div>
  )
}

export default PaletteCell